/* src/app/dialogs/import-documentlines-wizard/import-document-lines-wizard.component.css */
a:link,
a:visited {
  color: #000000;
  text-decoration: underline;
}
a:hover,
a:active {
  color: #000000;
  text-decoration: none;
}
/*# sourceMappingURL=import-document-lines-wizard.component-427OZZ2R.css.map */
